import React, { useEffect, useState } from "react";
import { Button, Form, Image, Input, notification, Select, Upload, Space } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { GrUpload } from "react-icons/gr";
import CategoryRequest from "../../Categories/CategoryRequest";
import { useNavigate, useParams } from "react-router-dom";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const EditProfile = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();




  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) => {
    // Set the new file list and clear any existing preview image.
    setFileList(newFileList);
    if (newFileList.length > 0) {
      // Get the new image's URL or preview, if available.
      const newFile = newFileList[0];
      setPreviewImage(newFile.url || newFile.preview);
    } else {
      setPreviewImage("");
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }}>
      <GrUpload />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const imageUpload = (file, name) => {
    setLoading(true);

    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    CategoryRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          categoryImage: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };
  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {

      imageUpload(file, file.name);
      return false;
    },
    onRemove() {
      setFileList([]);
    },
  };


  return (
    <section>
      <div className="Create-Category">
        <div span={24}>
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
        </div>
        <h3>Edit Customer Profile</h3>

        <Form
          form={form}
        //   onFinish={onFinish}
          layout="vertical"
          initialValues={null}
          className="subscription-form"
          colon
        >
          <div className="subscription">
            <Form.Item
              label="Name"
              name="name"
              className="subscription-plan"
              rules={[{ required: true, message: "Please enter the customer name!" },
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Category name can only contain alphabetic characters!",
              },
              ]}
            >
              <Input size="large" placeholder="Enter customer Name" />
            </Form.Item>
            <Form.Item
  label="Mobile Number"
  name="number"
  className="subscription-plan"
  rules={[
    { required: true, message: "Please enter the customer mobile number!" },
    {
      pattern: /^[0-9]{10}$/,
      message: "Mobile number must be a valid 10-digit number!",
    },
  ]}
>
  <Input size="large" placeholder="Enter customer mobile number" />
</Form.Item>

          </div>

          <div className="subscription">
          <Form.Item
  label="Email"
  name="email"
  className="subscription-plan"
  rules={[
    { required: true, message: "Please enter the customer email!" },
    {
      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Please enter a valid email address!",
    },
  ]}
>
  <Input size="large" placeholder="Enter customer email" />
</Form.Item>

            <Form.Item
              label="Gender"
              name="gender"
              className="subscription-plan"
              rules={[{ required: true, message: "Please select the  gender" }]}
            >
              <Select
                placeholder="Select The Category Gender"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "0", label: "Male" },
                  { value: "1", label: "Female" },
                ]}
              />
            </Form.Item>
          </div>

          <div className="upload-Img">
            <Form.Item
              label="Upload Salon Images"
              name="categoryImage"
              className="subscription-plan"
            // rules={[{ required: true, message: "Please upload the salon images" }]}
            >
              <Upload {...props} maxCount={1}

                listType="picture-card"
                fileList={fileList}
                className="upload-Img-input"
                onPreview={handlePreview}
                onChange={handleImageChange}
              >
                {fileList.length >= 8 ? null : uploadButton}
              </Upload>
              {previewImage && (
                <Image
                  wrapperStyle={{ display: "none" }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) => !visible && setPreviewImage(""),
                  }}
                  src={previewImage}
                />
              )}
            </Form.Item>
          </div>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save & Proceed
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default EditProfile;
